// @flow

import type { Action } from './store.type';

// Extract styles
export const SS_EXTRACT_STYLES_REQUEST = 'SS_EXTRACT_STYLES_REQUEST';
type SS_EXTRACT_STYLES_REQUEST_TYPE = 'SS_EXTRACT_STYLES_REQUEST';

export const SS_EXTRACT_STYLES_SUCCESS = 'SS_EXTRACT_STYLES_SUCCESS';
type SS_EXTRACT_STYLES_SUCCESS_TYPE = 'SS_EXTRACT_STYLES_SUCCESS';

export const SS_EXTRACT_STYLES_FAILURE = 'SS_EXTRACT_STYLES_FAILURE';
type SS_EXTRACT_STYLES_FAILURE_TYPE = 'SS_EXTRACT_STYLES_FAILURE';

type SmartStylingFailure = {
  error: any
};

type SSExtractStylesRequestAction = Action<SS_EXTRACT_STYLES_REQUEST_TYPE, null>;

type SSExtractStylesSuccessAction = Action<SS_EXTRACT_STYLES_SUCCESS_TYPE, { data: any }>;

type SSExtractStylesFailureAction = Action<SS_EXTRACT_STYLES_FAILURE_TYPE, SmartStylingFailure>;

// Apply styles
export const SS_APPLY_STYLES_REQUEST = 'SS_APPLY_STYLES_REQUEST';
type SS_APPLY_STYLES_REQUEST_TYPE = 'SS_APPLY_STYLES_REQUEST';

export const SS_APPLY_STYLES_SUCCESS = 'SS_APPLY_STYLES_SUCCESS';
type SS_APPLY_STYLES_SUCCESS_TYPE = 'SS_APPLY_STYLES_SUCCESS';

export const SS_APPLY_STYLES_FAILURE = 'SS_APPLY_STYLES_FAILURE';
type SS_APPLY_STYLES_FAILURE_TYPE = 'SS_APPLY_STYLES_FAILURE';

type SSApplyStylesRequestAction = Action<SS_APPLY_STYLES_REQUEST_TYPE, null>;

type SSApplyStylesSuccessAction = Action<SS_APPLY_STYLES_SUCCESS_TYPE, { data: any }>;

type SSApplyStylesFailureAction = Action<SS_APPLY_STYLES_FAILURE_TYPE, SmartStylingFailure>;

// Extract and map styles
export const SS_EXTRACT_AND_APPLY_STYLES_REQUEST = 'SS_EXTRACT_AND_APPLY_STYLES_REQUEST';
type SS_EXTRACT_AND_APPLY_STYLES_REQUEST_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_REQUEST';

export const SS_EXTRACT_AND_APPLY_STYLES_SUCCESS = 'SS_EXTRACT_AND_APPLY_STYLES_SUCCESS';
type SS_EXTRACT_AND_APPLY_STYLES_SUCCESS_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_SUCCESS';

export const SS_EXTRACT_AND_APPLY_STYLES_FAILURE = 'SS_EXTRACT_AND_APPLY_STYLES_FAILURE';
type SS_EXTRACT_AND_APPLY_STYLES_FAILURE_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_FAILURE';

type SSExtractAndApplyStylesRequestAction = Action<SS_EXTRACT_AND_APPLY_STYLES_REQUEST_TYPE, null>;

type SSExtractAndApplyStylesSuccessAction = Action<
  SS_EXTRACT_AND_APPLY_STYLES_SUCCESS_TYPE,
  { data: any }
>;

type SSExtractAndApplyStylesFailureAction = Action<
  SS_EXTRACT_AND_APPLY_STYLES_FAILURE_TYPE,
  SmartStylingFailure
>;

// Extract and map styles with input url
export const SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST =
  'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST';
type SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST';

export const SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS =
  'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS';
type SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS';

export const SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE =
  'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE';
type SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE_TYPE = 'SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE';

type SSExtractAndApplyStylesOpenAIRequestAction = Action<
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST_TYPE,
  null
>;

type SSExtractAndApplyStylesOpenAISuccessAction = Action<
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS_TYPE,
  { data: any }
>;

type SSExtractAndApplyStylesOpenAIFailureAction = Action<
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE_TYPE,
  SmartStylingFailure
>;

// Backup template settings
export const SS_BACKUP_TEMPLATE_SETTINGS = 'SS_BACKUP_TEMPLATE_SETTINGS';
type SS_BACKUP_TEMPLATE_SETTINGS_TYPE = 'SS_BACKUP_TEMPLATE_SETTINGS';

type SSBackupTemplateSettingsAction = Action<SS_BACKUP_TEMPLATE_SETTINGS_TYPE, { data: any }>;

// Clear extracted styling
export const SS_CLEAR_EXTRACTED_STYLES = 'SS_CLEAR_EXTRACTED_STYLES';
type SS_CLEAR_EXTRACTED_STYLES_TYPE = 'SS_CLEAR_EXTRACTED_STYLES';

type SSClearExtractedStylesAction = Action<SS_CLEAR_EXTRACTED_STYLES_TYPE, { data: any }>;

// Mark applied styles
export const SS_MARK_APPLIED_STYLES = 'SS_MARK_APPLIED_STYLES';
type SS_MARK_APPLIED_STYLES_TYPE = 'SS_MARK_APPLIED_STYLES';

type SSMarkAppliedStylesAction = Action<SS_MARK_APPLIED_STYLES_TYPE, { data: any }>;

// Close error fetching modal
export const SS_CLOSE_ERROR_FETCHING_MODAL = 'SS_CLOSE_ERROR_FETCHING_MODAL';
type SS_CLOSE_ERROR_FETCHING_MODAL_TYPE = 'SS_CLOSE_ERROR_FETCHING_MODAL';

type SSCloseErrorFetchingModalAction = Action<SS_CLOSE_ERROR_FETCHING_MODAL_TYPE, { data: any }>;

export type SmartStylingAction =
  | SSClearExtractedStylesAction
  | SSMarkAppliedStylesAction
  | SSCloseErrorFetchingModalAction
  | SSBackupTemplateSettingsAction
  | SSExtractStylesRequestAction
  | SSExtractStylesSuccessAction
  | SSExtractStylesFailureAction
  | SSApplyStylesRequestAction
  | SSApplyStylesSuccessAction
  | SSApplyStylesFailureAction
  | SSExtractAndApplyStylesRequestAction
  | SSExtractAndApplyStylesSuccessAction
  | SSExtractAndApplyStylesFailureAction
  | SSExtractAndApplyStylesOpenAIRequestAction
  | SSExtractAndApplyStylesOpenAISuccessAction
  | SSExtractAndApplyStylesOpenAIFailureAction;

export type SmartStylingState = {
  extractStylesLoading: boolean,
  extractStylesSuccess: boolean,
  extractStylesError: boolean,
  extractedStyles: Object,

  applyStylesLoading: boolean,
  applyStylesSuccess: boolean,
  updatedTemplateSettings: Object,
  backupTemplateSettings: Object,

  extractAndApplyStylesLoading: boolean,
  extractAndApplyStylesSuccess: boolean,
  extractAndApplyStylesError: boolean,

  extractAndApplyStylesOpenAILoading: boolean,
  extractAndApplyStylesOpenAISuccess: boolean,
  extractAndApplyStylesOpenAIError: boolean,

  appliedStyles: boolean
};
